/* eslint-disable max-len */
import React from 'react';

const THCVAIcon = (props) => (
  <svg width='62' height='36' viewBox='0 0 62 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M35.9625 10.8627C37.1685 10.8627 38.0505 9.99866 38.0505 8.79266C38.0505 7.58666 37.1685 6.72266 35.9625 6.72266C34.7505 6.72266 33.8685 7.58666 33.8685 8.79266C33.8685 9.99866 34.7505 10.8627 35.9625 10.8627ZM35.9625 10.1067C35.2185 10.1067 34.7445 9.53666 34.7445 8.79266C34.7445 8.04266 35.2185 7.47866 35.9625 7.47866C36.7005 7.47866 37.1745 8.04266 37.1745 8.79266C37.1745 9.53666 36.7005 10.1067 35.9625 10.1067Z'
      fill='#4F5D68'
    />
    <path
      d='M42.2484 10.7907V6.78866H41.3904V8.36066H39.5004V6.78866H38.6484V10.7907H39.5004V9.10466H41.3904V10.7907H42.2484Z'
      fill='#4F5D68'
    />
    <path
      d='M20.9625 35.8627C22.1685 35.8627 23.0505 34.9987 23.0505 33.7927C23.0505 32.5867 22.1685 31.7227 20.9625 31.7227C19.7505 31.7227 18.8685 32.5867 18.8685 33.7927C18.8685 34.9987 19.7505 35.8627 20.9625 35.8627ZM20.9625 35.1067C20.2185 35.1067 19.7445 34.5367 19.7445 33.7927C19.7445 33.0427 20.2185 32.4787 20.9625 32.4787C21.7005 32.4787 22.1745 33.0427 22.1745 33.7927C22.1745 34.5367 21.7005 35.1067 20.9625 35.1067Z'
      fill='#4F5D68'
    />
    <path
      d='M30.6605 11.7872V7.78516H29.8025V9.35716H27.9125V7.78516H27.0605V11.7872H27.9125V10.1012H29.8025V11.7872H30.6605Z'
      fill='#4F5D68'
    />
    <path
      d='M3.66055 28.7872V24.7852H2.80255V26.3572H0.912547V24.7852H0.0605469V28.7872H0.912547V27.1012H2.80255V28.7872H3.66055Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.9377 5.30457V0.179688H14.9377V5.30751L21.7174 9.00552V15.6914L26.1005 12.5923L27.2551 14.2253L22.5968 17.519L27.2952 20.1145L33.1354 17.0212V11.9017H35.1354V17.0495L42.0563 21.0963V28.5505L47.7704 31.7595L54.6207 27.9918L61.8144 32.0317L60.835 33.7755L54.6106 30.2799L47.7603 34.0477L41.0488 30.2785L34.133 34.0435L27.4725 30.3801L24.3571 33.5991L22.9199 32.2081L26.2852 28.7311V21.8414L20.698 18.7549L14.6124 21.8505L14.918 28.6738L18.7792 32.1615L17.4385 33.6457L14.4541 30.9498L13.3447 34.7862L11.4234 34.2306L12.4992 30.5106L8.66322 31.4338L8.19525 29.4893L12.9018 28.3566L12.6576 22.9048L6.80775 26.132L5.84167 24.3808L11.5821 21.214L6.08742 17.9096V9.00258L12.9377 5.30457ZM13.9352 7.03888L8.08742 10.1957V16.7785L13.6251 20.1088L19.7174 17.0099V10.1928L13.9352 7.03888ZM28.2852 21.8533V28.5446L34.1379 31.7637L40.0563 28.5416V22.2437L34.1114 18.7675L28.2852 21.8533Z'
      fill='#64737F'
    />
  </svg>
);
export default THCVAIcon;
